import { useEffect, useState } from 'react';
import * as actions from '@actions';
import { useDispatch } from 'react-redux';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useSessionFormState } from './useSessionFormState';
import { useSessionAppointment } from './useSessionAppointment';
import { useSessionAppointmentId } from './useSessionAppointmentId';

export function useAppointmentPrescriptions() {
  const dispatch = useDispatch();

  const appt_id = useSessionAppointmentId();
  const { appointment } = useSessionAppointment();

  const [prescribeMedication, setPrescribeMedication] = useSessionFormState(
    'prescribeMedication',
    Number(appointment?.prescribe_meds_flag) > 0
  );
  const [hasBeenUpdated, setHasBeenUpdated] = useSessionFormState('hasPrescriptionValueBeenUpdated', false);
  const [canPrescribe, setCanPrescribe] = useState(false);

  const { data: response } = useSuspenseQuery({
    queryKey: ['appointmentMetaData', appt_id],
    queryFn: () => dispatch(actions.appointmentMetaData(appt_id))
  });

  useEffect(() => {
    async function fetchData() {
      const meta = response?.meta?.[0];

      console.log({ meta });
      if (meta) {
        setCanPrescribe(meta.appt_prescriptions);
      }
    }

    if (appt_id) fetchData().then();
  }, [appt_id, canPrescribe, dispatch, response?.meta]);

  const updatePrescribeMedication = (val: boolean) => {
    dispatch(actions.setAppointmentWillPrescribe(appt_id, val || false)).then();

    setPrescribeMedication(val);

    setHasBeenUpdated(true);
  };

  return { canPrescribe, prescribeMedication, updatePrescribeMedication, hasBeenUpdated };
}

export default useAppointmentPrescriptions;
